import { makeStyles, Theme } from '@material-ui/core/styles'
import { createStyles } from '@material-ui/core'
import { grey, orange, indigo } from '@material-ui/core/colors'

// @ts-ignore
export const useListedItemBadgesStyles = makeStyles((theme: Theme) =>
  createStyles({
    badgeBlock: {
      position: 'absolute',
      top: theme.spacing(1.5),
      left: theme.spacing(1.5),
      right: 'auto',
      zIndex: 2,
      '& .MuiBadge-badge': {
        position: 'relative',
        transform: 'none',
        borderRadius: theme.shape.borderRadius,
      },
    },
    badgeBlockActive: {
      '& .MuiBadge-badge': {
        background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
      },
    },
    badgeBlockDraft: {
      '& .MuiBadge-badge': {
        background: `linear-gradient(135deg, ${grey['500']} 0%, ${grey['600']} 100%)`,
      },
    },
    badgeBlockSellPending: {
      '& .MuiBadge-badge': {
        background: `linear-gradient(135deg, ${orange['500']} 0%, ${orange['600']} 100%)`,
      },
    },
    badgeBlockSold: {
      '& .MuiBadge-badge': {
        background: `linear-gradient(135deg, ${theme.palette.info.main} 0%, ${theme.palette.info.dark} 100%)`,
      },
    },
    badgeBlockUnlisted: {
      '& .MuiBadge-badge': {
        background: `linear-gradient(135deg, ${indigo['400']} 0%, ${indigo['600']} 100%)`,
      },
    },
    badgeBlockNew: {
      '& .MuiBadge-badge': {
        background: `linear-gradient(135deg, ${theme.palette.success.main} 0%, ${theme.palette.success.dark} 100%)`,
      },
    },
  })
)
